module.exports = __webpack_public_path__ + "img/l_image@3x.293f2886.png";